import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * Custom translation loader that caches translations in memory
 * to prevent redundant HTTP requests on route changes
 */
export class CachedTranslateHttpLoader implements TranslateLoader {
  private translationCache = new Map<string, any>();
  
  constructor(
    private http: HttpClient,
    public prefix: string = '/assets/i18n/',
    public suffix: string = '.json'
  ) {}
  
  /**
   * Gets translation for the specified language
   * @param lang Language code (e.g., 'en', 'en-cdss', 'es')
   * @returns Observable with translation data
   */
  public getTranslation(lang: string): Observable<any> {
    // Check cache first
    if (this.translationCache.has(lang)) {
      return of(this.translationCache.get(lang));
    }
    
    // Load from server and cache the result
    return this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(
      tap(translations => {
        this.translationCache.set(lang, translations);
      })
    );
  }
  
  /**
   * Clears the translation cache (useful for testing or forced reloads)
   */
  public clearCache(): void {
    this.translationCache.clear();
  }
}

